export const TH = dm => ({
  BG:     dm ? '#080c10'               : '#f0f4f8',
  PANEL:  dm ? '#0d1820'               : '#ffffff',
  PANELBG:dm ? '#0a1018'               : '#e8f2f8',
  BORDER: dm ? 'rgba(0,216,240,0.1)'   : 'rgba(0,80,130,0.22)',
  TEXT:   dm ? '#e0eaf0'               : '#0a1520',
  DIM:    dm ? '#4a7080'               : '#1e3a52',
  DIMLT:  dm ? '#2a4050'               : '#3a6070',
  CYAN:   dm ? '#00d8f0'               : '#0070a8',
  EMBER:  '#f26b3b',
  WARN:   dm ? '#f0a020'               : '#9a5a00',
});

export const lbl = dm => ({
  fontSize: '9px', fontFamily: 'monospace',
  color: dm ? '#3a6070' : '#1a3a52',
  letterSpacing: '0.15em', textTransform: 'uppercase',
  marginBottom: '5px', fontWeight: '700',
});

export const fi = dm => ({
  outline: 'none', fontFamily: 'inherit',
  background: dm ? 'rgba(0,216,240,0.04)' : '#ffffff',
  border: dm ? '1px solid rgba(0,216,240,0.15)' : '1px solid rgba(0,80,130,0.3)',
  borderRadius: '8px', padding: '9px 12px',
  color: dm ? '#d0e8f0' : '#0a1520',
  fontSize: '13px', width: '100%',
  boxSizing: 'border-box', colorScheme: dm ? 'dark' : 'light',
});
